import React from 'react'
import { Avatar, Card, CardHeader, CardActions, CardContent, CardMedia, IconButton, Typography, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MoreVert, GitHub, Launch, MenuBook } from '@material-ui/icons';
import { red } from '@material-ui/core/colors';
import ProjectModal from './ProjectModal';

import noImage from '../img/imgNotAvail.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  avatar: {
    backgroundColor: red[500],
  },
  centerCard: {
    alignContent: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  customHoverFocus: {
    "&:hover, &.Mui-focusVisible": { backgroundColor: "lightblue" }
  }
}));



const DataCard = (item) => {
  const project = item.item;
  const classes = useStyles();

  const image = project.Image;

  const handleModal = () => {
    return (
      <ProjectModal project={project} />
    );
  }

  return (
    <React.Fragment>
      <div className={classes.centerCard}>

        <Card className={classes.root} onClick={handleModal}>
          <CardHeader
            avatar={
              <Avatar aria-label="project" className={classes.avatar}>
                {project.Type.charAt(0)}
              </Avatar>
            }
            action={
              <IconButton aria-label="settings">
                <MoreVert />
              </IconButton>
            }
            titleTypographyProps={{variant:'h6' }}
            title={project.Title}
          />
          <CardMedia
            className={classes.media}
            image={image || noImage}
            title={project.Title}
          />
          <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
              {project.Description}
            </Typography>
          </CardContent>
          <CardActions disableSpacing>
            {project.GitHub !== "false" ?
              <Tooltip title='GitHub Repo'>
                <IconButton className={classes.customHoverFocus} aria-label="go to GitHub">
                  <GitHub onClick={() => window.open(project.GitHub)} />
                </IconButton>
              </Tooltip>
              : null
            }
            {project.GhPages !== "false" ?
              <Tooltip title='Live Site'>
                <IconButton aria-label="live project" className={classes.customHoverFocus}>
                  <Launch onClick={() => window.open(project.GhPages)}/>
                </IconButton>
              </Tooltip>
              : null
            }
            {project.Tutorial !== "false" ?
              <Tooltip title='Tutorial Page'>
                <IconButton aria-label="tutorial" className={classes.customHoverFocus}>
                  <MenuBook onClick={() => window.open(project.Tutorial)}/>
                </IconButton> 
              </Tooltip>
              : null
            }
          </CardActions>

        </Card>
      </div>
    </React.Fragment>
  )
}

export default DataCard
